import React from 'react'
import DashBitesSection from '../../components/DashComponents/DashBitesSection'

function DashBites() {
  return (
    <div>
      <DashBitesSection/>
    </div>
  )
}

export default DashBites